import * as THREE from "three";

export const cameraPersp = function () {
    this.camera = new THREE.PerspectiveCamera(70, 500 / 500, 1, 10000);

    this.camera.position.set(0, 0, 200);
    this.camera.lookAt(0,0,0);
    this.radius = 100;

    return this.camera;
}


